import * as z from 'zod';
import { type ApiEnvelope } from './api-envelope';

export function getErrorFromApiEnvelope(apiEnvelope: ApiEnvelope<unknown>): string | undefined {
  if (apiEnvelope.hasErrors && apiEnvelope.error?.errorDetails) {
    return apiEnvelope.error.errorDetails;
  }

  return undefined;
}

const apiEnvelopeSchema = z.object({
  content: z.unknown(),
  success: z.boolean(),
  hasErrors: z.boolean(),
  error: z
    .object({
      errorCode: z.string().trim(),
      errorDetails: z.string().trim(),
      exception: z.string().trim().optional(),
    })
    .optional()
    .nullable(),
});

export function isApiEnvelope<T = unknown>(object: unknown): object is ApiEnvelope<T> {
  const parsedObject = apiEnvelopeSchema.safeParse(object);
  return parsedObject.success;
}
